import { render, staticRenderFns } from "./RoyText.vue?vue&type=template&id=4cc63eb8&"
import script from "./RoyText.vue?vue&type=script&lang=js&"
export * from "./RoyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports